import { render } from "./Mint.vue?vue&type=template&id=e8d2be7a&ts=true"
import script from "./Mint.vue?vue&type=script&lang=ts"
export * from "./Mint.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/isamu/ss/web3/laidbacklu/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__